import React from 'react';
import { Button } from 'react-bootstrap';

export default function ReturnToSearch() {
  return (
    <Button
      href={process.env.REACT_APP_AUDITOR_PROPERTYSEARCH}
      target="_blank"
      rel="noreferrer"
      variant="secondary"
      aria-label="Search Properties on Auditor's Website"
    >
      Search Properties
    </Button>
  );
}
